// extracted by mini-css-extract-plugin
export default {"problems":"jlYS6mohEVxngL_6Uh_u","problemsTitle":"zNOiLOpYLtvi9q1z0RmO"};